import { BellRing, Share, X } from "lucide-react";
import { PushPromptMode } from "../api/push";
import "./NotificationPrompt.css";

interface NotificationPromptProps {
  mode: Exclude<PushPromptMode, null>;
  busy: boolean;
  error: string;
  onAllow: () => void;
  onClose: () => void;
}

export function NotificationPrompt({
  mode,
  busy,
  error,
  onAllow,
  onClose,
}: NotificationPromptProps) {
  const installIos = mode === "install-ios";
  const blocked = mode === "blocked";
  const repair = mode === "repair";
  return (
    <div className="notification-prompt-backdrop" role="presentation">
      <section
        className="notification-prompt"
        role="dialog"
        aria-modal="true"
        aria-labelledby="notification-prompt-title"
      >
        <button
          className="notification-prompt-close"
          type="button"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <X size={20} />
        </button>
        <div className="notification-prompt-icon">
          {installIos ? <Share size={28} /> : <BellRing size={28} />}
        </div>
        <h2 id="notification-prompt-title">
          {installIos
            ? "Уведомления на iPhone"
            : blocked
              ? "Уведомления заблокированы"
              : repair
                ? "Переподключите уведомления"
              : "Не пропускайте сообщения"}
        </h2>
        {installIos ? (
          <p>
            Нажмите «Поделиться» в браузере, выберите «На экран Домой», затем
            откройте INNOPROG Чаты Авито с новой иконки и разрешите уведомления.
          </p>
        ) : blocked ? (
          <p>
            Откройте настройки уведомлений браузера или системы, найдите
            avito.chat.innoprog.ru и разрешите уведомления для этого сайта.
          </p>
        ) : repair ? (
          <p>
            Разрешение уже выдано, но push-подписку не удалось восстановить.
            Нажмите кнопку ниже, чтобы подключить её повторно.
          </p>
        ) : (
          <p>
            Разрешите уведомления, чтобы получать имя клиента и текст нового
            сообщения, даже когда чат закрыт.
          </p>
        )}
        {error && <div className="notification-prompt-error">{error}</div>}
        <div className="notification-prompt-actions">
          {!installIos && !blocked && (
            <button
              className="notification-prompt-primary"
              type="button"
              onClick={onAllow}
              disabled={busy}
            >
              {busy
                ? "Подключаем…"
                : repair
                  ? "Переподключить уведомления"
                  : "Разрешить уведомления"}
            </button>
          )}
          <button
            className="notification-prompt-secondary"
            type="button"
            onClick={onClose}
          >
            {installIos || blocked ? "Понятно" : "Не сейчас"}
          </button>
        </div>
      </section>
    </div>
  );
}
